// Originally derived from THREE.GLTFLoader
// https://github.com/mrdoob/three.js/blob/master/examples/js/loaders/GLTFLoader.js

import { FileLoader } from "./fileloader";
import { BINARY_HEADER_MAGIC, GLTFBinaryData } from "./glb-decoder";
import { GltfAsset } from "./gltf-asset";
import { LoaderUtils } from "./loaderutils";

// main library exports
import * as gltf from "./gltf";
export { gltf };
export * from "./gltf-asset";

/** Main class of the library */
export class GltfLoader {
    /**
     * Load glTF from a URL. Only the main file is loaded - external buffer and image files
     * are loaded lazily when needed. To load all, you can use `GltfAsset.preFetchAll()`
     */
    async load(url: string): Promise<GltfAsset> {
        // TODO!!: test data URI here
        const path = LoaderUtils.extractUrlBase(url);

        const data = await FileLoader.load(url);
        const asset = await this.parse(data, path);
        return asset;
    }

    private async parse(data: ArrayBuffer, path: string): Promise<GltfAsset> {
        let content: string;
        // tslint:disable-next-line:no-unnecessary-initializer
        let glbData: GLTFBinaryData | undefined = undefined;
        if (typeof data === "string") {
            content = data;
        } else {
            const magic = LoaderUtils.decodeText(new Uint8Array(data, 0, 4));
            if (magic === BINARY_HEADER_MAGIC) {
                glbData = new GLTFBinaryData(data);
                content = glbData.json;
            } else {
                content = LoaderUtils.decodeText(new Uint8Array(data));
            }
        }

        const json = JSON.parse(content);

        if (json.asset === undefined || json.asset.version[0] < 2) {
            throw new Error("Unsupported asset. glTF versions >=2.0 are supported.");
        }

        return new GltfAsset(json, path, glbData);
    }
}
